import {nextTick} from "vue";
import {isWebMcpActionsEnabled, isWebMcpEnabled, registerTools, unregisterTools} from "@/functions/webMcp";
import {getCurrentRoute, isRouteReady, markStepReady, markToolsReady, setCurrentRoute} from "@/functions/webMcpStep";
import {dialogKey} from "@/functions/webMcpDom";
import {buildGlobalTools} from "@/functions/webMcpToolsGlobal";
import {buildGeneratedTools} from "@/functions/webMcpToolsGenerated";
import {signInTools} from "@/functions/webMcpToolsSignIn";
import {twoStepTools} from "@/functions/webMcpToolsTwoStep";
import {createAccountTools} from "@/functions/webMcpToolsCreateAccount";
import {reclaimTools} from "@/functions/webMcpToolsReclaim";
import {accountTools} from "@/functions/webMcpToolsAccount";
import {preparerTools} from "@/functions/webMcpToolsPreparer";

const ROUTE_TOOLS = [signInTools, twoStepTools, createAccountTools, reclaimTools, accountTools, preparerTools]
const DIALOG_SETTLE_MS = 150

let registeredDialog = ''
let dialogTimer

export const routeToolBuilders = (routeName) => ROUTE_TOOLS.flatMap((group) => group[routeName] ?? [])

const allowed = (tools) => (isWebMcpActionsEnabled() ? tools : tools.filter((tool) => !tool.isAction))

export const buildRouteTools = (route, router) => {
	const curated = routeToolBuilders(route.name).flatMap((build) => build({route, router}))
	return allowed([...curated, ...buildGeneratedTools({route, hasCuratedTools: curated.length > 0})])
}

export const registerGlobalWebMcpTools = (router) => {
	if (!isWebMcpEnabled()) return Promise.resolve([])
	setCurrentRoute(router.currentRoute.value)
	return registerTools('global', allowed(buildGlobalTools({router})))
}

export const registerRouteWebMcpTools = async (route, router) => {
	setCurrentRoute(route)
	unregisterTools('route')
	await nextTick()
	const isCurrent = await markStepReady(route)
	if (!isCurrent || !isWebMcpEnabled()) return []
	registeredDialog = dialogKey()
	const names = await registerTools('route', buildRouteTools(route, router))
	markToolsReady(route)
	return names
}

export const refreshRouteToolsForDialog = async (router) => {
	const route = getCurrentRoute()
	if (!route || !isRouteReady() || !isWebMcpEnabled() || dialogKey() === registeredDialog) return []
	registeredDialog = dialogKey()
	const names = await registerTools('route', buildRouteTools(route, router))
	markToolsReady(route)
	return names
}

export const watchDialogs = (router) => {
	const observer = new MutationObserver((mutations) => {
		if (!mutations.some((mutation) => mutation.target.classList?.contains('modal-backdrop'))) return
		clearTimeout(dialogTimer)
		dialogTimer = setTimeout(() => void refreshRouteToolsForDialog(router), DIALOG_SETTLE_MS)
	})
	observer.observe(document.body, {attributes: true, attributeFilter: ['class'], subtree: true})
	return observer
}